import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";

//
import ScrollBar from "react-perfect-scrollbar";
import {
  Card,
  InputGroup,
  FormControl,
  Dropdown,
  Row,
  Col,
  Form,
  Button,
  Tooltip,
  OverlayTrigger,
  Spinner,
} from "react-bootstrap";

//
import { getTicket, sendAnswer } from "../../redux/features/tickets/actions";

//
import BothSideLineTitle from "../general/BothSideLineTitle";
import BoxLoading from "../general/BoxLoading";
import ImageModal from "./ImageModal";

//
import User from "../../assets/img/user.png";
import NoMessage from "../../assets/img/no-message.png";

//
import * as yup from "yup";
import { Formik } from "formik";
import Moment from "react-moment";

const schema = yup.object().shape({
  message: yup.string().required(),
});

function TicketContent({ selectedTicket, setSelectedTicket, mainCardHeight }) {
  const [show, setShow] = useState(false);
  const [imagePreview, setImagePreview] = useState("");

  //
  const hiddenFileInput = useRef(null);
  const [loading, setLoading] = useState(false);
  const [btnLoading, setBtnLoading] = useState(false);

  //
  const [ticket, setTicket] = useState([]);
  const [attachments, setAttachments] = useState([]);

  /**
   * Open Image Preview Modal
   */
  const openImagePreviewModal = (image) => {
    setImagePreview(image);
    setShow(true);
  };

  /**
   * Send Invite Link
   */
  const send_answer = async (e, { resetForm }) => {
    // start loading
    setBtnLoading(true);

    // set variables
    let id = selectedTicket.id;
    let fd = new FormData();
    fd.append("message", e.message);
    if (attachments.length) {
      for (let i = 0; i < attachments.length; i++) {
        const file = attachments[i];
        fd.append("imageFile[]", file);
      }
    }

    // send request
    await sendAnswer({ id, fd }).then((res) => {
      if (res) {
        convertTicket(res);

        resetForm({
          values: "",
        });

        setAttachments([]);
      }
    });

    setBtnLoading(false);
  };

  /**
   * Get Ticket
   */
  const get_ticket = async () => {
    if (selectedTicket) {
      // start loading
      setLoading(true);

      // set variable
      let id = selectedTicket.id;

      // request
      await getTicket(id).then((res) => {
        if (res) {
          convertTicket(res);
        }
      });

      // stop loading
      setLoading(false);
    }
  };

  const convertTicket = (ticket) => {
    let newTicket = [];

    //
    for (const [key, value] of Object.entries(ticket)) {
      let dayTime = key.replace("_", "-").replace("_", "-");
      let chats = [];

      for (const [k, v] of Object.entries(value)) {
        chats.push({
          time: k.replace("_", ":"),
          items: v,
        });

        newTicket.push({ dayTime, chats });
      }
    }

    //
    setTicket(newTicket);
  };

  useEffect(() => {
    get_ticket();

    // eslint-disable-next-line
  }, [selectedTicket]);

  const inputClick = (e) => {
    hiddenFileInput.current.click();
  };

  /**
   * Add Attachments
   */
  const addFile = (e) => {
    let attach = [...attachments];

    for (let i = 0; i < e.target.files.length; i++) {
      const element = e.target.files[i];

      //
      attach.push(element);
    }

    setAttachments(attach);
  };

  /**
   * Remove Attachment
   */
  const removeFile = (i) => {
    let attach = [...attachments];

    attach = attach.filter((item, index) => index != i);

    setAttachments(attach);
  };

  const ticketStatusColor = () => {
    let status = selectedTicket.status;

    if (status === "open") return "success";
    if (status === "close") return "danger";
    if (status === "pending") return "warning";
  };

  return (
    <>
      <ImageModal show={show} setShow={setShow} image={imagePreview} />
      {selectedTicket ? (
        <Card>
          <Card.Header>
            <div className="d-flex align-items-center">
              <span className="d-flex d-md-none">
                <i
                  className="las la-angle-left"
                  onClick={() => setSelectedTicket(null)}
                ></i>
              </span>
              <img src={User} alt="user img" className="rounded-full" />
              <div>
                <h5>{selectedTicket.title}</h5>
                <small className={`fw-bolder text-${ticketStatusColor()}`}>
                  {selectedTicket.status}
                </small>
              </div>
            </div>

            <Dropdown align="end">
              <Dropdown.Toggle className="no-border">
                <i className="las la-ellipsis-v"></i>
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <ScrollBar>
                  <Dropdown.Item>item</Dropdown.Item>
                  <Dropdown.Item>Hide</Dropdown.Item>
                </ScrollBar>
              </Dropdown.Menu>
            </Dropdown>
          </Card.Header>

          <Card.Body>
            <ScrollBar style={{ height: `${mainCardHeight - 188}px` }}>
              {ticket.map((chat, index) => (
                <div key={index}>
                  <Row className="justify-content-center">
                    <Col md={10}>
                      <BothSideLineTitle
                        text={
                          <Moment utc format="MMMM DD, YYYY">{chat.dayTime}</Moment>
                        }
                      />
                    </Col>
                  </Row>

                  {chat.chats.map((item, index) => (
                    <div
                      key={index}
                      className={`item-box ${
                        item.items[0].user_type === "client" ? "user" : ""
                      }`}
                    >
                      {item.items.map((item, index) => (
                        <>
                          <small className="item" key={index}>
                            {item.message}
                          </small>

                          {item.imageable.length ? (
                            <div className="img-holder">
                              {item.imageable.map((img, i) => (
                                <span
                                  key={i}
                                  onClick={() =>
                                    openImagePreviewModal(img.path)
                                  }
                                  style={{
                                    backgroundImage: `url(${img.path})`,
                                  }}
                                />
                              ))}
                            </div>
                          ) : (
                            <></>
                          )}
                        </>
                      ))}
                      <small className="time">
                        <i
                          className={`las la-check${
                            item.items[0].read ? "-double" : ""
                          } text-success`}
                        ></i>
                        {item.time}
                      </small>
                    </div>
                  ))}
                </div>
              ))}
            </ScrollBar>
          </Card.Body>

          <Card.Footer>
            <Formik
              validationSchema={schema}
              onSubmit={send_answer}
              initialValues={{
                message: "",
              }}
            >
              {({ handleSubmit, handleChange, touched, errors, values }) => (
                <Form noValidate onSubmit={handleSubmit} className="w-100">
                  <InputGroup>
                    <FormControl
                      type="text"
                      name="message"
                      placeholder="Type here..."
                      onChange={handleChange}
                      autoComplete="off"
                      value={values.message}
                      isInvalid={touched.message && !!errors.message}
                    />
                    <InputGroup.Text>
                      <div className="icons">
                        <OverlayTrigger
                          placement="top"
                          delay={{ show: 250, hide: 1000 }}
                          overlay={
                            <Tooltip>
                              {attachments.length ? (
                                <>
                                  {attachments.map((file, index) => (
                                    <p className="d-flex align-items-center justify-content-between flex-wrap mb-2">
                                      <span>{file.name}</span>

                                      <i
                                        className="lar la-times-circle ms-1"
                                        onClick={() => removeFile(index)}
                                      ></i>
                                    </p>
                                  ))}
                                </>
                              ) : (
                                <p>no file selected</p>
                              )}
                            </Tooltip>
                          }
                        >
                          <i className="las la-file" onClick={inputClick}></i>
                        </OverlayTrigger>

                        <input
                          type="file"
                          ref={hiddenFileInput}
                          multiple
                          className="d-none"
                          onChange={addFile}
                        />
                      </div>
                      <Button variant="info" className="h-100" type="submit">
                        <span className="d-none d-md-block">Send message</span>
                        <i className="lab la-telegram d-block d-md-none"></i>
                        {btnLoading && (
                          <div className="spinner-holder">
                            <Spinner
                              animation="border"
                              variant="white"
                              size="sm"
                            />
                          </div>
                        )}
                      </Button>
                    </InputGroup.Text>
                  </InputGroup>
                </Form>
              )}
            </Formik>
          </Card.Footer>

          {loading && <BoxLoading />}
        </Card>
      ) : (
        <div className="no-ticket-selected">
          <div className="d-flex flex-column align-items-center">
            <span className="img-holder">
              <img src={NoMessage} alt="np-message" />
            </span>
            <h5 className="text-muted">Select chat to see conversation</h5>
          </div>
        </div>
      )}
    </>
  );
}

TicketContent.propTypes = {
  selectedTicket: PropTypes.object.isRequired,
  setSelectedTicket: PropTypes.func.isRequired,
  mainCardHeight: PropTypes.number.isRequired,
};

export default TicketContent;
